import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";

import { Button, Grid, IconButton, useMediaQuery } from '@mui/material'
import IconsColor from '../../utility/iconsColor';
import AddIcon from '@mui/icons-material/Add';
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import { useSearchParams } from 'react-router-dom';
import { GlobalTable } from '../../utility/globalTable';
import { chatbotListInterface, chatbotPersistentMenu, chatbotPersistentPayload } from '../../../models/axiosModel';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import PersistentMenuModal from '../../popupFiles/persistentMenuModal';
import agent from '../../../services/api';
import globalStrenameDocumentyles from "../../../assets/renameDocument.svg";
import deleteDoc from "../../../assets/deleteDoc.svg";
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { formatDateTime } from '../../../utils/constants';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotPersistentmenuBreadcrumb, homeBreadcrumb } from '../../../utils/breadcrumb';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { HeaderListObjectModel } from '../../../models/componentModel';
import GlobalPopUp from '../../utility/globalPopUp';
import persistentMenuStyle from "../../../assets/styles/componentStyles/persistentStyles/persistent.module.scss";
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

export interface parentPersistentMenuName {
    chatbot_persistent_menu_id: number,
    chatbot_persistent_menu_name: string,
    chatbot_persistent_menu_value: string,
    // target_chatbot_id?: string,
}

const PersistentMenu = () => {

    let headerList = [
        {
            name: '',
            alignment: "left",
            flagIcon: false,
            valueKey: "",
            iconKey: "addIcon",
            flagHover: true,
        },
        {
            name: "#",
            alignment: "left",
            flagIcon: false,
            valueKey: "",
            iconKey: "sequenceNumber"
        },
        {
            name: "Menu Item Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "chatbot_persistent_menu_name",
            iconKey: "menu_item_name"
        },
        {
            name: "Action Type",
            alignment: "left",
            flagIcon: false,
            valueKey: "",
            iconKey: "action_type"
        },
        {
            name: "Action",
            alignment: "left",
            flagIcon: false,
            valueKey: "",
            iconKey: "action"
        },
        {
            name: "Sub Chatbot Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "target_chatbot_name",
            iconKey: "chatbot",
        },
        {
            name: "Created At",
            alignment: "left",
            flagIcon: false,
            valueKey: "created_at_timestamp",
            iconKey: "created_at_timestamp"
        },
        {
            name: "",
            alignment: "right",
            flagIcon: true,
            valueKey: "",
            iconKey: "editIcon"
        },
    ]

    const menuItems = [
        {
            label: 'Edit',
            icon: <img alt="" src={globalStrenameDocumentyles} />,
            action: (e: chatbotPersistentMenu) => {
                setHandleEdit(e)
            }
        },
        {
            label: 'Delete',
            icon: <img src={deleteDoc} alt="delete" />,
            action: (e: chatbotPersistentMenu) => deleteDocumentDataPopupOpen(e)
        },
    ];

    const menuItemOnClickOfAddIcon = [
        {
            label: "Add New menu Item",
            action: (e: HeaderListObjectModel, rowDetail: chatbotPersistentMenu) => {
                setSelectedActionType("Text");
                setRequestPersistentMenuDetailsList({
                    ...requestPersistentMenuDetailsList,
                    chatbot_persistent_menu_id: 0,
                    chatbot_persistent_menu_name: "",
                    chatbot_persistent_menu_value: "",
                    target_chatbot_id: undefined,
                    target_chatbot_name: "-",
                    static_message_id: undefined, 
                    chatbot_static_message_name: "-",
                    parent_chatbot_persistent_menu_id: rowDetail.parent_chatbot_persistent_menu_id,
                });
                setFlagKeyExistError(false)
                setFlagOpenMenuItemDialog(true)
            }
        },
        {
            label: "Add Sub Menu Item",
            action: (e: HeaderListObjectModel, rowDetail: chatbotPersistentMenu) => {
                if (e.iconKey === "addIcon") {
                    setSelectedActionType("Text");
                    setParentPersistentMenuName({
                        ...parentPersistentMenuName,
                        chatbot_persistent_menu_id: rowDetail.chatbot_persistent_menu_id,
                        chatbot_persistent_menu_name: rowDetail.chatbot_persistent_menu_name,
                        chatbot_persistent_menu_value: rowDetail.chatbot_persistent_menu_value,
                    })

                    setFlagKeyExistError(false);
                    setFlagOpenMenuItemDialog(true);
                    setRequestPersistentMenuDetailsList({
                        ...requestPersistentMenuDetailsList,
                        chatbot_persistent_menu_id: 0,
                        chatbot_persistent_menu_name: "",
                        chatbot_persistent_menu_value: "",
                        target_chatbot_id: rowDetail.target_chatbot_id ? rowDetail.target_chatbot_id : undefined,
                        target_chatbot_name: chatbotList?.find((chatbot: chatbotListInterface) => chatbot.chatbot_id === String(rowDetail.target_chatbot_id))?.chatbot_name ?? "-",
                        static_message_id: undefined,
                        chatbot_static_message_name: "-",
                        parent_chatbot_persistent_menu_id: undefined,
                    });
                    setFlagOpenSubMenuItemDialog(true);
                }
            }
        }
    ]

    const [searchParams] = useSearchParams();
    const { chatBotDetails, setChatBotDetails, chatbotStaticMessageFormat, setChatbotStaticMessageFormat, chatbotList, GetChatbotDataApi } = useContext(ChatbotContext) as ChatbotContextPayload
    const chatbot_id = searchParams.get('chatbot_id');
    const {
        setFlagLoading,
        handleError,
    } = useContext(UserContext) as UserContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [adjustedHeaderList, setAdjustedHeaderList] = useState(headerList);
    const [persistentMenuDetailsList, setPersistentMenuDetailsList] = useState<chatbotPersistentMenu[]>();
    const [requestPersistentMenuDetailsList, setRequestPersistentMenuDetailsList] = useState<chatbotPersistentMenu>({
        chatbot_persistent_menu_id: 0,
        chatbot_persistent_menu_name: "",
        chatbot_persistent_menu_value: "",
        target_chatbot_id: undefined,
        target_chatbot_name: "-",
        static_message_id: undefined,  
        chatbot_static_message_name: "-",
        created_at_timestamp: "",
        parent_chatbot_persistent_menu_id: undefined,
    });
    const [flagOpenMenuItemDialog, setFlagOpenMenuItemDialog] = useState<boolean>(false);
    const [flagDeletePersistentMenuDataDialog, setFlagDeletePersistentMenuDataDialog] = useState<boolean>(false);
    const [deletePersistentDialogId, setDeletePersistentDialogId] = useState<number | null>(null);
    const [deletePersistentName, setDeletePersistentName] = useState<string>("");
    const [flagKeyExistError, setFlagKeyExistError] = useState<boolean>(false);

    const [flagOpenSubMenuItemDialog, setFlagOpenSubMenuItemDialog] = useState<boolean>(false);
    const [parentPersistentMenuName, setParentPersistentMenuName] = useState<parentPersistentMenuName>({
        chatbot_persistent_menu_id: 0,
        chatbot_persistent_menu_name: "",
        chatbot_persistent_menu_value: "",
    });

    const [selectedActionType, setSelectedActionType] = useState<string>("Text");
    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }
    let pathname = window.location.pathname.toLowerCase();

    const formatPersistentMenuData = (menuData: chatbotPersistentMenu[]) => {
        return menuData.map(ele => {
            const formattedData = {
                ...ele,
                target_chatbot_name: (ele.target_chatbot_id != chatbot_id && ele.target_chatbot_name) ? ele.target_chatbot_name : "-",
                created_at_timestamp: formatDateTime(ele?.created_at_timestamp, "dmyTime"),
            };
            if (ele.sub_chatbot_persistent_menu) {
                formattedData.sub_chatbot_persistent_menu = formatPersistentMenuData(ele.sub_chatbot_persistent_menu);
            }
            return formattedData;
        });
    };

    useEffect(() => {
        if (chatBotDetails) {
            // getStaticMessageFormats()
            const persistentMenuData: chatbotPersistentMenu[] = chatBotDetails?.chatbot_persistent_menu ? formatPersistentMenuData(chatBotDetails.chatbot_persistent_menu) : [];
            setPersistentMenuDetailsList(persistentMenuData);
            const updatedBreadcrumbs = [
                // ...((pathname != '/' && pathname != '/chatbot') ? [{...homeBreadcrumb, path: '/chatbot'}] : []), 
                {...homeBreadcrumb},
                AIChatbotBreadcrumb, 
                {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`},
                {...chatbotPersistentmenuBreadcrumb, isActive: true}, 
            ]; 
            setBreadCrumbs(updatedBreadcrumbs);
        }
    }, [chatBotDetails])

    const getStaticMessageFormatApiCall = async (chatbot_id: string) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await agent.getStaticMessageFormat.get(chatbot_id);
        if (res.status) {
            setChatbotStaticMessageFormat(res.data);
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleChange = (field: string, value: string | number | undefined) => {
        if (field == "target_chatbot_id") {
            setRequestPersistentMenuDetailsList((prevState: any) => ({
                ...prevState,
                static_message_id: null,
                target_chatbot_id: value,
                target_chatbot_name: chatbotList?.find((chatbot: chatbotListInterface) => chatbot.chatbot_id === String(value))?.chatbot_name ?? "-"
            }));
            if (value) {
                getStaticMessageFormatApiCall(String(value));
            } else {
                getStaticMessageFormatApiCall(chatBotDetails?.chatbot_id ? String(chatBotDetails?.chatbot_id) : "")
            }
        } else {
            setRequestPersistentMenuDetailsList(({
                ...requestPersistentMenuDetailsList,
                [field]: value
            }));
        }
    };

    const findChatbotName = (target_chatbot_id: string) => {
        if (target_chatbot_id != chatbot_id && chatbotList && chatbotList.find((chatbot: chatbotListInterface) => chatbot.chatbot_id == String(target_chatbot_id))) {
            return chatbotList.find((chatbot: chatbotListInterface) => chatbot.chatbot_id == String(target_chatbot_id))?.chatbot_name || "-";
        }
        else {
            return "-";
        }
    }

    const addSubMenuItem = (menuList: chatbotPersistentMenu[], newItem: chatbotPersistentMenu): chatbotPersistentMenu[] => {
        return menuList.map(item => {
            if (item.chatbot_persistent_menu_id === newItem.parent_chatbot_persistent_menu_id) {
                return {
                    ...item, 
                    target_chatbot_name: findChatbotName(newItem.target_chatbot_id || ""), 
                    chatbot_static_message_name: newItem.chatbot_static_message_name ? newItem.chatbot_static_message_name : "-",
                    sub_chatbot_persistent_menu: [
                        ...(item.sub_chatbot_persistent_menu || []),
                        newItem
                    ]
                };
            } else if (item.sub_chatbot_persistent_menu?.length) {
                return {
                    ...item,
                    target_chatbot_name: findChatbotName(newItem.target_chatbot_id || ""),
                    chatbot_static_message_name: newItem.chatbot_static_message_name ? newItem.chatbot_static_message_name : "-",
                    sub_chatbot_persistent_menu: addSubMenuItem(item.sub_chatbot_persistent_menu, newItem)
                };
            } else {
                return item;
            }
        });
    };

    const updateSubMenu = (submenu: chatbotPersistentMenu[], updatedMenu: chatbotPersistentMenu): chatbotPersistentMenu[] => {
        return submenu.map((item: chatbotPersistentMenu) => {
            if (item.chatbot_persistent_menu_id === updatedMenu.chatbot_persistent_menu_id) {
                return {
                    ...updatedMenu,
                    target_chatbot_name: findChatbotName(updatedMenu.target_chatbot_id || ""), 
                    chatbot_static_message_name: updatedMenu.chatbot_static_message_name ? updatedMenu.chatbot_static_message_name : "-",
                    created_at_timestamp: formatDateTime(updatedMenu.created_at_timestamp, "dmyTime"),
                    ...(item.sub_chatbot_persistent_menu?.length && {
                        sub_chatbot_persistent_menu: item.sub_chatbot_persistent_menu
                    })
                }
            } else if (item.sub_chatbot_persistent_menu?.length) {
                return {
                    ...item, 
                    target_chatbot_name: findChatbotName(item.target_chatbot_id || ""), 
                    chatbot_static_message_name: item.chatbot_static_message_name ? item.chatbot_static_message_name : "-",
                    sub_chatbot_persistent_menu: updateSubMenu(item.sub_chatbot_persistent_menu, updatedMenu),
                }
            } else {
                return item;
            }
        })
    };
    const handleSavePersistentData = async () => {
        let createPayload: chatbotPersistentPayload = {
            chatbot_id: searchParams.get('chatbot_id') ?? "",
            target_chatbot_id: requestPersistentMenuDetailsList.target_chatbot_id ? requestPersistentMenuDetailsList.target_chatbot_id : undefined,
            chatbot_persistent_menu_name: requestPersistentMenuDetailsList.chatbot_persistent_menu_name,
        }

        switch (selectedActionType) {
            case "Text":
                createPayload.chatbot_persistent_menu_value = requestPersistentMenuDetailsList.chatbot_persistent_menu_value;
                break;
            case "Static Message":
                createPayload.static_message_id = String(requestPersistentMenuDetailsList.static_message_id);
                break;
            case "None":
                createPayload.chatbot_persistent_menu_value = "";
                break;
        }

        if (flagOpenSubMenuItemDialog) {
            createPayload.parent_chatbot_persistent_menu_id = String(parentPersistentMenuName.chatbot_persistent_menu_id);
        } else if (requestPersistentMenuDetailsList?.parent_chatbot_persistent_menu_id !== undefined && requestPersistentMenuDetailsList?.parent_chatbot_persistent_menu_id != null) {
            createPayload.parent_chatbot_persistent_menu_id = String(requestPersistentMenuDetailsList.parent_chatbot_persistent_menu_id);
        }

        let updatePayload = {
            chatbot_id: searchParams.get('chatbot_id') ?? "",
            chatbot_persistent_menu_id: requestPersistentMenuDetailsList.chatbot_persistent_menu_id,
            chatbot_persistent_menu_name: requestPersistentMenuDetailsList.chatbot_persistent_menu_name,
            target_chatbot_id: requestPersistentMenuDetailsList.target_chatbot_id ? requestPersistentMenuDetailsList.target_chatbot_id : undefined,
            ...((selectedActionType === "Text") && { chatbot_persistent_menu_value: requestPersistentMenuDetailsList.chatbot_persistent_menu_value }),
            ...((selectedActionType === "None") && { chatbot_persistent_menu_value: "" }),
            ...((selectedActionType === "Static Message") && { static_message_id: requestPersistentMenuDetailsList.static_message_id }),
        }

        const { chatbot_persistent_menu_name, chatbot_persistent_menu_value, chatbot_persistent_menu_id } = requestPersistentMenuDetailsList;

        if (!chatbot_persistent_menu_id) {
            const isDuplicate = persistentMenuDetailsList && persistentMenuDetailsList.some((item: chatbotPersistentMenu) => (
                item?.chatbot_persistent_menu_name == chatbot_persistent_menu_name
            ));

            if (isDuplicate) {
                setFlagKeyExistError(true);
                return;
            }
        }

        if (chatbot_persistent_menu_id) {
            // Update flow
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            const response = await agent.updatePersistentMenuAPI.put(updatePayload);

            if (response.status) {
                await GetChatbotDataApi(Number(chatBotDetails?.chatbot_id))
                let updatedData = response.data[0];
                updatedData.target_chatbot_name = findChatbotName(updatedData.target_chatbot_id || "");

                setPersistentMenuDetailsList((prevList) => updateSubMenu(prevList ? prevList : [], updatedData))
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                showSuccess("Persistent details saved successfully!")
                setFlagOpenMenuItemDialog(false);
                setFlagOpenSubMenuItemDialog(false);
                setFlagKeyExistError(false);
            } else {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                handleError(response);

                setFlagOpenMenuItemDialog(false);
                setFlagOpenSubMenuItemDialog(false);
                setFlagKeyExistError(false);
            }
        } else {
            // Create flow
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            const response = await agent.createPersistentMenuAPI.post(createPayload);

            if (response.status) {
                if (response.data) {
                    await GetChatbotDataApi(Number(chatBotDetails?.chatbot_id))
                    const newItem = {
                        ...response.data[0],
                        target_chatbot_name: findChatbotName(response?.data[0]?.target_chatbot_id || ""),
                        created_at_timestamp: formatDateTime(response?.data[0]?.created_at_timestamp, "dmyTime"), 
                        chatbot_static_message_name: response.data[0]?.chatbot_static_message_name ? response.data[0]?.chatbot_static_message_name : "-",
                    };

                    if (newItem.parent_chatbot_persistent_menu_id === null) {
                        setPersistentMenuDetailsList(persistentMenuDetailsList ? [...persistentMenuDetailsList, newItem] : [newItem]);
                    } else {
                        setPersistentMenuDetailsList((prevList) =>
                            addSubMenuItem(prevList ? prevList : [], newItem)
                        );

                        // Update Action Type to None for parent menu of this sub menu.  
                        if (parentPersistentMenuName.chatbot_persistent_menu_value === null || parentPersistentMenuName.chatbot_persistent_menu_value?.length > 0) {
                            const payload = {
                                chatbot_id: searchParams.get('chatbot_id') ?? "",
                                chatbot_persistent_menu_id: parentPersistentMenuName.chatbot_persistent_menu_id,
                                chatbot_persistent_menu_name: parentPersistentMenuName.chatbot_persistent_menu_name,
                                chatbot_persistent_menu_value: "",
                            }

                            const res = await agent.updatePersistentMenuAPI.put(payload);
                            if (res.status) {
                                let data = res.data[0];
                                data.target_chatbot_name = findChatbotName(data.target_chatbot_id || "");
                                setPersistentMenuDetailsList((prevList) => updateSubMenu(prevList ? prevList : [], data))
                            } else {
                                handleError(res);
                            }
                        }
                    }

                    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                    showSuccess("Persistent details saved successfully!")
                }
                setFlagOpenMenuItemDialog(false);
                setFlagOpenSubMenuItemDialog(false);
                setFlagKeyExistError(false);
            }
            else {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                handleError(response);

                setFlagOpenMenuItemDialog(false);
                setFlagOpenSubMenuItemDialog(false);
                setFlagKeyExistError(false);
            }
        }
    }


    const setHandleEdit = (rowDetail: chatbotPersistentMenu) => {
        setFlagKeyExistError(false)
        setFlagOpenMenuItemDialog(true)
        setRequestPersistentMenuDetailsList(rowDetail)
    }

    const deleteDocumentDataPopupOpen = (data: chatbotPersistentMenu) => {
        setFlagDeletePersistentMenuDataDialog(true)
        setDeletePersistentDialogId(data.chatbot_persistent_menu_id)
        setDeletePersistentName(data.chatbot_persistent_menu_name)
    }

    const handleOpenEditDialog = async (e: HeaderListObjectModel, rowDetail: chatbotPersistentMenu) => {
        if (e.iconKey !== "editIcon" && e.iconKey !== "addIcon") {
            setHandleEdit(rowDetail)
        }
    }

    const deletePersistentMenuById = (menuList: chatbotPersistentMenu[], id: number): chatbotPersistentMenu[] => {
        return menuList
            .filter((item: chatbotPersistentMenu) => item.chatbot_persistent_menu_id !== id)
            .map((item: chatbotPersistentMenu) => ({
                ...item,
                target_chatbot_name: findChatbotName(item.target_chatbot_id || ""),
                sub_chatbot_persistent_menu: item.sub_chatbot_persistent_menu
                    ? deletePersistentMenuById(item.sub_chatbot_persistent_menu, id)
                    : []
            }));
    };

    const handleDeletePersistentDetail = async (id: number | null) => {
        if (id) {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            const removeDataResponse = await agent.removePersistentMenuDataAPI.delete(id);
            if (removeDataResponse.status) {
                if (persistentMenuDetailsList) {
                    setPersistentMenuDetailsList(deletePersistentMenuById(persistentMenuDetailsList, id));
                }
                setFlagDeletePersistentMenuDataDialog(false)
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                showSuccess(removeDataResponse?.data?.message)
            } else {
                setFlagDeletePersistentMenuDataDialog(false)
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                handleError(removeDataResponse);
            }
        }
    }

    const isActionTypeDisabled = () => {
        let sub_chatbot_persistent_menu = findSelectedMenu(persistentMenuDetailsList as chatbotPersistentMenu[]);
        if (sub_chatbot_persistent_menu != undefined && sub_chatbot_persistent_menu.length > 0 && selectedActionType === "None") {
            return true;
        }
        return false;
    }

    const findSelectedMenu = (menuList: chatbotPersistentMenu[]): chatbotPersistentMenu[] | undefined => {
        for (const item of menuList) {
            if (item.chatbot_persistent_menu_id === requestPersistentMenuDetailsList.chatbot_persistent_menu_id) {
                return item.sub_chatbot_persistent_menu;
            }

            if (item.sub_chatbot_persistent_menu) {
                const foundMenu: chatbotPersistentMenu[] | undefined = findSelectedMenu(item.sub_chatbot_persistent_menu);
                if (foundMenu) {
                    return foundMenu;
                }
            }
        }
    }

    const handleRowClickOfPersistentMenuTable = (e: chatbotPersistentMenu) => {
        if (e.static_message_id) {
            setSelectedActionType("Static Message");
        } else if (e.chatbot_persistent_menu_value?.length > 0 && e.chatbot_persistent_menu_value != null) {
            setSelectedActionType("Text");
        } else {
            setSelectedActionType("None");
        }
    }

    const innerHeight = (window.innerHeight - 190);

    return (
        <>
            {flagOpenMenuItemDialog &&

                <GlobalPopUp
                    open={flagOpenMenuItemDialog}
                    onClose={() => { setFlagOpenSubMenuItemDialog(false); setFlagOpenMenuItemDialog(false); setFlagKeyExistError(false); }}
                    handleClose={() => { setFlagOpenSubMenuItemDialog(false); setFlagOpenMenuItemDialog(false); setFlagKeyExistError(false); }}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    flagBackdrop
                >
                    <PersistentMenuModal
                        setFlagOpenMenuItemDialog={setFlagOpenMenuItemDialog}

                        handlePersistentMenuDetails={handleChange}
                        handleSavePersistentData={handleSavePersistentData}

                        requestPersistentMenuDetailsList={requestPersistentMenuDetailsList}
                        setRequestPersistentMenuDetailsList={setRequestPersistentMenuDetailsList}

                        flagKeyExistError={flagKeyExistError}
                        setFlagKeyExistError={setFlagKeyExistError}

                        flagOpenSubMenuItemDialog={flagOpenSubMenuItemDialog}
                        setFlagOpenSubMenuItemDialog={setFlagOpenSubMenuItemDialog}

                        parentPersistentMenuName={parentPersistentMenuName}

                        selectedActionType={selectedActionType}
                        setSelectedActionType={setSelectedActionType}

                        isActionTypeDisabled={isActionTypeDisabled}

                        getStaticMessageFormatApiCall={getStaticMessageFormatApiCall}
                    />
                </GlobalPopUp>
            }

            {flagDeletePersistentMenuDataDialog &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${deletePersistentName}`}
                    open={flagDeletePersistentMenuDataDialog}
                    onClose={() => { setFlagDeletePersistentMenuDataDialog(false) }}
                    onDelete={() => { handleDeletePersistentDetail(deletePersistentDialogId) }}
                />
            }

            <Grid container>
                <Grid item xl={12} xs={12}
                    className={`${globalStyles.fullwidth} ${globalStyles.dashboardChildWrapper} ${styles.dataConnectorDashboard}`}
                >
                    <Grid container className={persistentMenuStyle.mainContainer}>
                        <Grid item xs={12} sx={{ maxWidth: persistentMenuDetailsList && persistentMenuDetailsList.length > 5 ? '305px !important' : 'auto' }} className={`${globalStyles.globalHeadRightSubItem} ${styles.globalAddConnectorButton}`}>
                            <Grid container className={persistentMenuStyle.mainContainer}>
                                <Grid item>
                                    <Grid container className={persistentMenuStyle.innerGridContainer}>
                                        {window.screen.width >= 900 &&
                                            <>
                                                <Grid item className={persistentMenuStyle.textAlignEnd}>
                                                    <Button
                                                        variant='outlined'
                                                        size='large'
                                                        startIcon={<IconsColor iconName="plusIcon" width={"16"} height={"16"} fill={"#FFF"} />}
                                                        className={`${styles.newConnectorBtn} ${persistentMenuStyle.menuItemBtn}`}
                                                        onClick={() => {
                                                            setSelectedActionType("Text");
                                                            setFlagOpenMenuItemDialog(true)
                                                            setFlagKeyExistError(false)
                                                            setRequestPersistentMenuDetailsList({
                                                                ...requestPersistentMenuDetailsList,
                                                                chatbot_persistent_menu_id: 0,
                                                                chatbot_persistent_menu_name: "",
                                                                chatbot_persistent_menu_value: "",
                                                                target_chatbot_id: undefined,
                                                                target_chatbot_name: "-",
                                                                static_message_id: undefined, 
                                                                chatbot_static_message_name: "-",
                                                                parent_chatbot_persistent_menu_id: undefined,
                                                            });
                                                        }}
                                                    >
                                                        Menu Item
                                                    </Button>
                                                </Grid>
                                            </>
                                        }
                                        {window.screen.width <= 899 &&
                                            <>
                                                <IconButton
                                                    className={`${globalStyles.cmpGlobalMobileAddIcon}`}
                                                    onClick={() => {
                                                        setSelectedActionType("Text");
                                                        setFlagOpenMenuItemDialog(true)
                                                        setFlagKeyExistError(false)
                                                        setRequestPersistentMenuDetailsList({
                                                            ...requestPersistentMenuDetailsList,
                                                            chatbot_persistent_menu_id: 0,
                                                            chatbot_persistent_menu_name: "",
                                                            chatbot_persistent_menu_value: "",
                                                            target_chatbot_id: undefined,
                                                            target_chatbot_name: "-",
                                                            static_message_id: undefined, 
                                                            chatbot_static_message_name: "-",
                                                            parent_chatbot_persistent_menu_id: undefined,
                                                        });
                                                    }}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </>
                                        }
                                    </Grid>
                                </Grid>


                            </Grid >
                        </Grid >

                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${styles.documentsTableItem} ${persistentMenuStyle.marginTop}`} height={`${innerHeight}px !important`}>
                            <GlobalTable
                                headerList={adjustedHeaderList}
                                rowData={(persistentMenuDetailsList !== undefined && persistentMenuDetailsList?.length && persistentMenuDetailsList !== null) && persistentMenuDetailsList}
                                tableHeight={"76vh"}
                                tableContainerMinHeight={"auto"}
                                menuItemsFromParent={menuItems}
                                menuItemOnClickOfAddIcon={menuItemOnClickOfAddIcon}
                                rowAllowEdit={true}
                                flagPagination
                                onCellClick={(e: HeaderListObjectModel, rowDetail: chatbotPersistentMenu) => {
                                    handleOpenEditDialog(e, rowDetail)
                                }}
                                onRowClick={(e: chatbotPersistentMenu) => handleRowClickOfPersistentMenuTable(e)}
                                deleteRowData={deleteDocumentDataPopupOpen}
                                selectedActionType={selectedActionType}
                            />
                        </Grid>
                    </Grid >
                </Grid >
            </Grid >
        </>
    )
}

export default PersistentMenu